// @module POAItems
define('POAItems.View'
,	[
	'Facets.ItemCell.View',
	'ProductDetails.Full.View',
	'ProductDetails.QuickView.View',
	'Backbone',
	'underscore'
    ]
, function (
	FacetsItemCellView,
	ProductDetailsFullView,
	ProductDetailsQuickViewView,
	Backbone,
	_
)
{
    'use strict';

	_.extend(FacetsItemCellView.prototype, {
		getContext: _.wrap(FacetsItemCellView.prototype.getContext, function (fn) {
			var context = fn.apply(this, arguments);
	
			var itemPrice = this.model.get('onlinecustomerprice');
			context.isPriceMissing = !itemPrice;
        	context.poaTooltipMessage = _('Price not available, please contact us for more information.').translate();
			if (!itemPrice) {
				if (this.$el) {
					this.$el.find('.cart-add-to-cart-button-button').prop('disabled', true);
					this.$el.find('[data-action="custom-add-to-cart"]').prop('disabled', true);
				} else if (this.$) {
					this.$('.cart-add-to-cart-button-button').prop('disabled', true);
					this.$('[data-action="custom-add-to-cart"]').prop('disabled', true);
				}
			}
			return context;
		})
	});

	_.extend(ProductDetailsFullView.prototype, {
		getContext: _.wrap(ProductDetailsFullView.prototype.getContext, function (fn) {
			var context = fn.apply(this, arguments);
	
			var item = this.model && this.model.get('item');
			var priceDetail = item && item.get('onlinecustomerprice_detail');
			var itemPrice = priceDetail && priceDetail.onlinecustomerprice;

			context.isPriceMissing = !itemPrice;
        	context.poaTooltipMessage = _('Price not available, please contact us for more information.').translate();
			return context;
		})
	});

	_.extend(ProductDetailsQuickViewView.prototype, {
		getContext: _.wrap(ProductDetailsQuickViewView.prototype.getContext, function (fn) {
			var context = fn.apply(this, arguments);
	
			var item = this.model && this.model.get('item');
			var priceDetail = item && item.get('onlinecustomerprice_detail');
			var itemPrice = priceDetail && priceDetail.onlinecustomerprice;

			context.isPriceMissing = !itemPrice;
        	context.poaTooltipMessage = _('Price not available, please contact us for more information.').translate();
			return context;
		})
	});
});
